import {LineupAnalyzer} from './lineup-analyzer';
import {MlbLineupAnalyzer} from './mlb-lineup-analyzer';
import Const from 'const';

const classesMap = {
    [Const.LEAGUE_MLB]: MlbLineupAnalyzer,
};

class Factory {
    public static getAnalyzer(sportConfig) {
        const sport = sportConfig.getSport().toLowerCase();

        return classesMap[sport] || LineupAnalyzer;
    }
}

export {Factory};
